import { useNavigate } from 'react-router';
import { Download, Eye } from 'lucide-react';
import { usePayrollRuns } from '@/api/queries/payroll.queries';
import { PageHeader } from '@/components/shared/PageHeader';
import { StatusBadge } from '@/components/shared/StatusBadge';
import { Button } from '@/components/ui/button';
import { formatCurrency } from '@/lib/formatters';

export default function PayrollHistoryPage() {
  const navigate = useNavigate();
  const { data: resp } = usePayrollRuns();
  const runs = resp?.data || [];

  return (
    <div className="space-y-5 fade-in">
      <PageHeader
        title="Payroll History"
        subtitle={`${runs.length} payroll runs`}
        breadcrumb={[{ label: 'Payroll', href: '/payroll' }, { label: 'History' }]}
        actions={<Button variant="outline" size="sm" icon={Download}>Export All</Button>}
      />

      <div className="card p-0 overflow-x-auto">
        <table className="w-full">
          <thead><tr className="border-b border-[var(--border)]">
            {['Pay Period','Employees','Gross','Net Pay','PF','TDS','Processed On','Status',''].map(h => (
              <th key={h} className="text-left text-[11px] font-semibold uppercase tracking-wide text-[var(--text-tertiary)] px-5 py-3">{h}</th>
            ))}
          </tr></thead>
          <tbody className="divide-y divide-[var(--border)]">
            {runs.map(r => (
              <tr key={r.id} className="hover:bg-[var(--bg-muted)] cursor-pointer" onClick={() => navigate(`/payroll/${r.id}`)}>
                <td className="px-5 py-3.5">
                  <p className="text-[13px] font-semibold text-[var(--text-primary)]">{r.pay_period}</p>
                  <p className="text-[11px] text-[var(--text-tertiary)]">{r.period_start || r.pay_period_start} → {r.period_end || r.pay_period_end}</p>
                </td>
                <td className="px-5 py-3.5 text-[13px] text-[var(--text-secondary)]">{r.total_employees}</td>
                <td className="px-5 py-3.5 text-[13px] font-medium text-[var(--text-primary)]">{formatCurrency(r.total_gross)}</td>
                <td className="px-5 py-3.5 text-[13px] font-bold text-green-600">{formatCurrency(r.total_net)}</td>
                <td className="px-5 py-3.5 text-[13px] text-[var(--text-secondary)]">{formatCurrency(r.total_pf || 0)}</td>
                <td className="px-5 py-3.5 text-[13px] text-[var(--text-secondary)]">{formatCurrency(r.total_tds || 0)}</td>
                <td className="px-5 py-3.5 text-[13px] text-[var(--text-secondary)]">{r.processed_on?.slice(0, 10) || '—'}</td>
                <td className="px-5 py-3.5"><StatusBadge status={r.status}/></td>
                <td className="px-5 py-3.5">
                  <button onClick={e => { e.stopPropagation(); navigate(`/payroll/${r.id}`); }}
                    className="flex items-center gap-1 text-[11px] font-semibold text-[var(--accent)] hover:underline">
                    <Eye size={11}/> View
                  </button>
                </td>
              </tr>
            ))}
            {runs.length === 0 && (
              <tr><td colSpan={9} className="px-5 py-12 text-center text-[14px] text-[var(--text-tertiary)]">No payroll runs yet</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
